<template>
    <div id="nav-layout" class="nav">
        <div class="nav-list">
            <div class="nav-item" :class="{ active: urlActive === '/' }" @click="onChangeUrl('/')">
                <span>{{ getTranslatedText('play') }}</span>
            </div>
            <div class="nav-item" @click="onShowModal(1)">
                <span>{{ getTranslatedText('How to play') }}</span>
            </div>
            <div class="nav-item" @click="onShowModal(2)">
                <span>{{ getTranslatedText('Fafi rules') }}</span>
            </div>
            <div
                class="nav-item"
                :class="{ active: urlActive === '/history' }"
                @click="onChangeUrl('/history')"
                v-if="this.$store.state.isLogin"
            >
                <span>{{ getTranslatedText('wager history') }}</span>
            </div>
        </div>
        <ModalCommon>
            <HowToPlay v-if="stepShowContent === 1" />
            <Rules v-else />
        </ModalCommon>
    </div>
</template>
<script>
import EventBus from '@/utils/EventBus'
import languageMixins from '@/mixins/language/language-mixins'
import HowToPlay from '@/components/how-to-play/index.vue'
import Rules from '@/components/rules/index.vue'
import ModalCommon from '@/components/common/modal.vue'

export default {
    mixins: [languageMixins],
    components: { HowToPlay, ModalCommon, Rules },
    data() {
        return {
            stepShowContent: 1,
            urlActive: '/',
        }
    },
    created() {
        this.urlActive = this.$router.history.current.path
        EventBus.$on('on-move-history', () => this.onChangeUrl('/history'))
    },
    destroyed() {
        EventBus.$off('on-move-history', null)
    },
    methods: {
        onShowModal(step) {
            this.stepShowContent = step
            EventBus.$emit('on-show-modal')
        },
        onChangeUrl(url) {
            if (this.urlActive !== url) {
                const query = this.$route.query
                this.urlActive = url
                this.$router.push({ path: url, query })
                document.documentElement.classList.remove('overflow-hidden')
            } else {
                EventBus.$emit('on-hide-screen-betslip-result')
            }
        },
    },
}
</script>

<style lang="scss">
@import '~ThemePath/scss/nav/index.scss';
</style>
